<template>
  <div>
    <slot name="header" :title="$t('privacy_notice')"></slot>
    <div class="wrapper">
      <div class="content PSLKanda4Pro">
        <div v-if="flag == 'en'" v-html="policyNoticeData.en"></div>
        <div v-if="flag == 'th'" v-html="policyNoticeData.th"></div>
        <span>
          <v-checkbox v-model="checkboxConsentSensitive" :disabled="Object.keys($store.state.member).length > 0 && !isEditSensitiveConsent" hide-details>
            <template v-slot:label>
              <div style="font-size: 14px; color: #000;">
                {{ $t("agree_consent_sensitive") }}
              </div>
            </template>
          </v-checkbox>
          <v-checkbox v-model="checkboxReceivePromotion" :disabled="Object.keys($store.state.member).length > 0 && !isEditSensitiveConsent" hide-details class="mb-5">
            <template v-slot:label>
              <div style="font-size: 14px; color: #000;">
                {{ $t("agree_information") }}
              </div>
            </template>
          </v-checkbox>
          <v-checkbox v-model="checkboxConsentPDPA" :disabled="Object.keys($store.state.member).length > 0 && !isEditSensitiveConsent" hide-details class="mb-5">
            <template v-slot:label>
              <div style="font-size: 14px; color: #000;">
                {{ $t("agree_consent_pdpa") }}
              </div>
            </template>
          </v-checkbox>
          <v-checkbox v-model="checkbox" hide-details :disabled="Object.keys(this.$store.state.member).length > 0 ? true : false">
            <template v-slot:label>
              <div style="font-size: 14px; color: #000;">
                {{ $t("agree_policy") }}
              </div>
            </template>
          </v-checkbox>
        </span>
      </div>
    </div>
    <div class="footer center">
      <template v-if="Object.keys($store.state.member).length > 0">
        <div>
          <v-btn dark width="150px" color="#330066" class="PSLKanda4Pro" rounded :loading="loading" @click="isEditSensitiveConsent = true" v-if="!isEditSensitiveConsent">
            {{ $t("edit_sensitive_consent") }}
          </v-btn>
          <v-btn dark width="150px" color="#330066" class="PSLKanda4Pro" rounded :loading="loading" @click="updateSensitiveConsent" v-else>
            {{ $t("save") }}
          </v-btn>
        </div>
        <div>
          <v-btn dark width="150px" class="error ml-3 PSLKanda4Pro" rounded @click="onDisagree">
            {{ $t("disagree") }}
          </v-btn>
        </div>
      </template>
      <template v-else>
        <v-btn dark width="200px" :disabled="!checkbox" :class="checkbox ? 'btn-purple' : 'btn-gray'" class="PSLKanda4Pro" rounded @click="submit">
          {{ $t("accept") }}
        </v-btn>
      </template>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import policyNoticeData from "@/data/policyNotice.js";
import i18n from "@/plugins/i18n";

export default {
  data() {
    return {
      checkbox: false,
      checkboxConsentSensitive: false,
      checkboxConsentPDPA: false,
      checkboxReceivePromotion: false,
      policyNoticeData: policyNoticeData,
      loading: false,
      isEditSensitiveConsent: false,
    };
  },
  computed: {
    flag() {
      return i18n.locale;
    },
  },
  mounted() {
    if (Object.keys(this.$store.state.member).length > 0) {
      this.checkbox = this.$store.state.member.consent;
      this.checkboxConsentSensitive = this.$store.state.member.sensitive_consent;
      this.checkboxConsentPDPA = this.$store.state.member.pdpa_consent;
      this.checkboxReceivePromotion = this.$store.state.member.receive_promotion;
    }
  },
  methods: {
    async submit() {
      let vm = this;
      vm.$store.state.receivePromotionStatus = vm.checkboxReceivePromotion;
      vm.$store.state.consentSensitiveStatus = vm.checkboxConsentSensitive;
      vm.$store.state.checkboxConsentPDPA = vm.checkboxConsentPDPA;
      vm.query.view = "Register";
    },
    async onDisagree() {
      const vm = this;
      await vm.$swal
        .fire({
          showCancelButton: true,
          confirmButtonText: vm.$t("confirm"),
          cancelButtonText: vm.$t("cancel"),
          html: vm.$t("disagree_consent_confirmation_1") + "<br/>" + vm.$t("disagree_consent_confirmation_2"),
          customClass: {
            actions: "swal-custom-action",
            content: "swal-custom-content",
            confirmButton: "swal-custom-btn-gray-outline",
            cancelButton: "swal-custom-btn-purple",
          },
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await vm.updateStatusConsent(false);
          }
        });
    },
    async updateSensitiveConsent() {
      const vm = this;
      if (vm.$store.state.member.sensitive_consent !== vm.checkboxConsentSensitive || vm.$store.state.member.receive_promotion !== vm.checkboxReceivePromotion || vm.$store.state.member.pdpa_consent !== vm.checkboxConsentPDPA) {
        let memberId = vm.$store.state.member.memberid;
        this.$store.state.member.sensitive_consent;
        const data = {
          pageid: vm.query.pageid,
        };

        if (vm.$store.state.member.sensitive_consent !== vm.checkboxConsentSensitive) {
          Object.assign(data, {
            sensitive_consent: vm.checkboxConsentSensitive,
          });
        }
        if (vm.$store.state.member.receive_promotion !== vm.checkboxReceivePromotion) {
          Object.assign(data, {
            receive_promotion: vm.checkboxReceivePromotion,
          });
        }
        if (vm.$store.state.member.pdpa_consent !== vm.checkboxConsentPDPA) {
          Object.assign(data, {
            pdpa_consent: vm.checkboxConsentPDPA,
          });
        }

        vm.loading = true;
        await axios
          .post(`${this.serverUrl}v1/member/updateSensitiveByMemberid/${memberId}`, data, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            vm.loading = false;
            if (response && response.data.responsecode == 200) {
              await vm.$store.dispatch("getMemberByUserId");
              await vm.$swal
                .fire({
                  text: vm.$t("update_success"),
                  confirmButtonColor: "#330066",
                  confirmButtonText: vm.$t("close"),
                })
                .then((result) => {
                  if (result) {
                    vm.query.view = "Profile";
                  }
                });
            }
          });
      } else {
        vm.loading = false;
        vm.$swal
          .fire({
            text: vm.$t("update_success"),
            confirmButtonColor: "#330066",
            confirmButtonText: vm.$t("close"),
          })
          .then((result) => {
            if (result) {
              vm.query.view = "Profile";
            }
          });
      }
    },
    async updateStatusConsent(status) {
      const vm = this;
      let memberId = vm.$store.state.member.memberid;
      let data = {
        consent: status,
      };
      await axios
        .post(`${this.serverUrl}v1/member/updateConsent/${memberId}`, data, {
          headers: {
            AUTHORIZATION: "Bearer xxx xxx",
          },
        })
        .then(async (response) => {
          if (response && response.data.responsecode == 200) {
            await vm.$swal
              .fire({
                html: vm.$t("disagree_success_1") + "<br/>" + vm.$t("disagree_success_2"),
                confirmButtonText: vm.$t("close"),
                customClass: {
                  content: "swal-custom-content",
                  confirmButton: "swal-custom-btn-purple",
                },
              })
              .then((result) => {
                if (result) {
                  if (vm.query.apptype == "line") {
                    vm.$liff.closeWindow();
                  } else {
                    vm.$store.dispatch("messengerClose");
                  }
                }
              });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  background: #e5e5e575;
  height: 100%;
}
.content {
  padding: 150px 24px 90px;
  max-width: 500px;
  margin: 0 auto;
  font-size: 16px;
}
.footer {
  position: fixed;
  bottom: 0;
  height: 80px;
  width: 100%;
  background: #ffffff;
}
</style>
